<div class="re-flex re-items-center re-justify-center re-flex-row re-mt-5 re-mb-10 re-fill-current">
  <div class="re-text-xs bold re-flex re-flex-row">{{ 'tariff.expectedBonus' | translate }} <div class="re-text-green">&nbsp;{{ bonusValue() | currency:'EUR'}}&nbsp;</div> <div>{{'tariff.perYear' | translate}}</div>
    <bdo-inline-tooltip class="re-flex re-ml-10">
      <span [innerHTML]="bonusInfo"></span>
    </bdo-inline-tooltip>
  </div>
</div>
